import {WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE } from "tools/webservice";

export const getSettings = (customerNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/customers/${customerNumber}/calc-settings`,
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const deleteSettings = (customerNumber, calcTypeCode, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/customers/${customerNumber}/calc-settings/${calcTypeCode}`,
  successCallback: successCallback,
  errorCallback: errorCallback,
  mountedRef: mountedRef,
});

export const addUpdateSettings = (customerNumber, calcTypeCode, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/customers/${customerNumber}/calc-settings/${calcTypeCode}`,
  payload: payload,
  successCallback: successCallback,
  errorCallback: errorCallback,
  mountedRef: mountedRef,
});